import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class CommonService {

  isOpen = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  orgInfo() {
    this.change.emit(this.isOpen);
  }
}
